import {TooltipWrapper} from '../Tooltip'

interface IIconIsActiveWrapperProps {
  text?: string
}

export const IconIsActive = ({text = 'Sem observações'}: IIconIsActiveWrapperProps) => {
  return (
    <TooltipWrapper tooltipText={text} tooltipPlacement='top'>
      <i className='ki-duotone ki-information fs-1 h-23 text-danger'>
        <span className='path1'></span>
        <span className='path2'></span>
        <span className='path3'></span>
      </i>
    </TooltipWrapper>
  )
}
